import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import RemumeSaudeLogged from '../../../../components/auth/saude/remume'

function RemumeSaudeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo da Relação Municipal de Medicamentos Essenciais" />
                <HeaderLogged />
                <Container>
                   <RemumeSaudeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default RemumeSaudeLoggedScreen;